import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import Container from "@/components/Container";
import Footer from "@/components/Footer";
import Nav from "@/components/Nav";
import { locumColors } from "@/theme";

const legalOnly = import.meta.env.VITE_LEGAL_ONLY === "true";

export default function NotFoundPage() {
  return (
    <>
      {!legalOnly && <Nav />}
      <Box component="main" sx={{ py: 16 }}>
        <Container>
          <Typography variant="h2" sx={{ mb: 2 }}>Page not found</Typography>
          <Typography color="text.secondary" sx={{ mb: 3 }}>
            The page you're looking for doesn't exist.
          </Typography>
          {!legalOnly && (
            <Link to="/" style={{ color: locumColors.teal, fontWeight: 600 }}>
              Back to home
            </Link>
          )}
        </Container>
      </Box>
      {!legalOnly && <Footer />}
    </>
  );
}
